import React from 'react'
import ActivityLMSCourse from '../feature/SkillBox/ActivityLMSCourse'

function ActivityLMSPurchase() {
  return (
    <ActivityLMSCourse/>
  )
}

export default ActivityLMSPurchase;